import { render, staticRenderFns } from "./CmsPage.vue?vue&type=template&id=c8d1ff3c&lang=pug&"
import script from "./CmsPage.vue?vue&type=script&lang=ts&"
export * from "./CmsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutPlaceholder: require('/var/www/linza-front/linza-front-20251107075108/node_modules/sitis-nuxt/lib/cms/LayoutPlaceholder.vue').default})
